import { useMemo } from "react";
import { preview, typeOf } from "@/lib/fieldCodec";
import { EditRecordButton } from "@/components/explorer/RecordEditor";

// Wide table: one column per field found across the given docs (every Firestore field, no curation).
export function AllFieldsTable({ rows, onOpen, testId, max = 60, path }) {
  const keys = useMemo(() => {
    const f = {};
    rows.forEach((r) => Object.keys(r).forEach((k) => { if (k !== "id") f[k] = (f[k] || 0) + 1; }));
    return Object.keys(f).sort();
  }, [rows]);
  return (
    <div className="overflow-auto max-h-[70vh] rounded-lg border border-border" data-testid={testId}>
      <table className="text-xs border-collapse">
        <thead className="sticky top-0 z-10 bg-secondary">
          <tr>
            <th className="sticky left-0 z-20 bg-secondary px-3 py-2 text-left font-mono font-semibold border-b border-r border-border">id</th>
            {keys.map((k) => <th key={k} className="px-3 py-2 text-left font-mono font-medium whitespace-nowrap border-b border-border">{k}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className={`hover:bg-accent/40 ${onOpen ? "cursor-pointer" : ""}`} onClick={() => onOpen?.(r)} data-testid={`${testId}-row-${r.id}`}>
              <td className="sticky left-0 bg-background px-3 py-1.5 font-mono text-primary whitespace-nowrap border-b border-r border-border"><span className="inline-flex items-center gap-1">{path && <EditRecordButton path={path} id={r.id} className="h-6 w-6" />}{r.id}</span></td>
              {keys.map((k) => (
                <td key={k} className="px-3 py-1.5 border-b border-border max-w-[260px] truncate whitespace-nowrap" title={r[k] === undefined ? "" : preview(r[k], 400)}>
                  {r[k] === undefined ? <span className="text-muted-foreground/50">—</span> : <span className={typeOf(r[k]) === "null" ? "text-muted-foreground" : ""}>{preview(r[k], max)}</span>}
                </td>
              ))}
            </tr>
          ))}
          {rows.length === 0 && <tr><td className="px-3 py-6 text-muted-foreground" colSpan={keys.length + 1}>No documents.</td></tr>}
        </tbody>
      </table>
      <p className="px-3 py-1.5 text-[10px] font-mono text-muted-foreground">{rows.length} docs · {keys.length} fields</p>
    </div>
  );
}
